import { N400 } from '@atlaskit/theme/colors';
import { wplToken } from '@atlassiansox/wpl-token';
import { getColor } from '@atlassiansox/wpl-utils';
import { css } from '@emotion/react';

export const containerStyle = css`
  border: 0.0625rem solid ${getColor('b400')};
`;

export const headerStyles = css`
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${wplToken('space.1000')};
  background-color: ${getColor('b400')};
  margin: 0;
  font-size: 1.5rem;
  font-weight: 400;
`;

export const disclaimerStyles = css`
  margin-top: 1.25rem;
  color: ${N400};
  font-size: 0.875rem;
  font-weight: 200;
  line-height: 1.125rem;
  letter-spacing: 0rem;
  text-align: left;
`;
